module.exports = __webpack_public_path__ + "img/logout.a5438183.svg";